/**
 * Convert an array of objects to CSV format.
 * Uses all unique keys from the objects as column headers.
 */
export default function convertToCSV<T>(items: T[]): string {
  if (items.length === 0) {
    return `result\nNo Data to Export`;
  }

  const headers = (() => {
    const allKeys = new Set<string>();
    items.forEach((item) => {
      Object.keys(item as object).forEach((key) => allKeys.add(key));
    });
    return Array.from(allKeys);
  })();

  const rows = items.map((item) => {
    return headers.map((key) => {
      const value = (item as Record<string, unknown>)[key];

      if (value instanceof Date) {
        return value.toISOString();
      }

      if (value === undefined) {
        return 'undefined';
      }

      if (value === null) {
        return 'null';
      }

      // Handle arrays and objects by converting them to JSON strings
      if (Array.isArray(value) || typeof value === 'object') {
        return JSON.stringify(value);
      }

      return String(value);
    });
  });

  return [headers, ...rows].map((row) => row.join(',')).join('\n');
}
